export default __webpack_public_path__ + "static/media/Witbooker_+_EN.bebb3af5.png";